import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

export const api = {
  // Artist
  getArtistInfo: () => axios.get(`${API_BASE}/artist`),
  
  // Releases
  getReleases: () => axios.get(`${API_BASE}/releases`),
  getRelease: (id) => axios.get(`${API_BASE}/releases/${id}`),
  
  // Lyrics
  getLyrics: () => axios.get(`${API_BASE}/lyrics`),
  getLyric: (id) => axios.get(`${API_BASE}/lyrics/${id}`),
  
  // Tracks
  getTracks: () => axios.get(`${API_BASE}/tracks`),
  getTrack: (id) => axios.get(`${API_BASE}/tracks/${id}`),
};

export default api;